module.exports = __webpack_public_path__ + "static/img/screenshot-4.c1100ce.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/screenshot-4.png
// module id = zZUc
// module chunks = 0